import { TYPE_SEAT } from 'sharedWebpack/helpers/itemTypes';
import { SEAT_ICON, BAGGAGE_ICON } from 'sharedWebpack/ProductIcon/productIconNames';

const getAncillaryIconName = type => (type === TYPE_SEAT ? SEAT_ICON : BAGGAGE_ICON);

export default getAncillaryIconName;
